import { render } from "./AdminNewVoucher.vue?vue&type=template&id=4ec3e780"
import script from "./AdminNewVoucher.vue?vue&type=script&lang=js"
export * from "./AdminNewVoucher.vue?vue&type=script&lang=js"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__